var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "imageContainer",
      staticClass: "a-image",
      class: _vm.containerClasses,
    },
    [
      _vm.fullResResolvedOnCreate
        ? _c("img", {
            staticClass: "full-res loaded",
            class: _vm.classes,
            attrs: {
              src: _vm.fullResImageSrc,
              alt: _vm.altText,
              title: _vm.titleText,
            },
          })
        : _vm.usePlaceholder
        ? _c("img", {
            staticClass: "loaded placeholder",
            class: _vm.classes,
            attrs: {
              src: _vm.placeholderSrc,
              alt: _vm.altText,
              title: _vm.titleText,
            },
          })
        : [
            _c("img", {
              ref: "fullResImage",
              staticClass: "full-res",
              class: _vm.classes,
              attrs: { alt: _vm.altText, title: _vm.titleText },
            }),
            _vm._v(" "),
            _c("img", {
              ref: "lowResImage",
              staticClass: "loaded low-res",
              class: _vm.classes,
              attrs: {
                src: _vm.lowResImageSrc,
                alt: _vm.altText,
                title: _vm.titleText,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }